(ns ycweb.app.website.voucher.common
  (:require
   [rum.core :as rum]
   [ycweb.components.common :as cmn]
   [ycweb.util.core :as u]
   [ycweb.util.urlstate :as urlstate]))

(rum/defc process-bar < rum/reactive cmn/cursors
  [app-atom {:keys [title step action]}]
  (let [process-atom (cmn/process-cursor app-atom)
        voucher-atom (rum/cursor process-atom :voucher)
        {:voucher/keys [method cover voucher-id] :as voucher} (rum/react voucher-atom)
        pdf? (= "pdf" method)]

    [:<>
     [:div.process-header.group
      [:h1.process-title
       title]
      [:aside.process-nav-wrapper
       [:ul.process-nav.group
        [:li.process-nav__item
         [:i {:class (u/bem :icon [:is-dark :email :small :inline])}]
         (if pdf? "Delivered as printable card. " "Delivered by email. ")
         [:a
          (merge
            (urlstate/href-props app-atom "gift-vouchers" action
              (u/maybe assoc
                {:method (if pdf? "email" "pdf")}
                :coverid (:cover/id cover)
                :voucherid voucher-id))
            {:class (u/bem :text-link [:muted])})
          (if pdf? "Change to email?" "Change to printable card?")]]]]]
     [:ol
      {:class (u/bem :process-bar [:03-step] :group)}
      [:li
       {:class (u/bem :process-step [(if (= step 1) :is-current :is-complete)])}
       (cond
         (or (= action "createvoucher") (= action "previewvoucher"))
         [:a.process-step__wrapper
          (merge
            (urlstate/href-props app-atom "gift-vouchers" "choosecover"
              (u/maybe assoc
                {:method method}
                :voucherid voucher-id))
            {:class "block-link"})
          [:span.align-outer-wrap
           [:span.align-inner-wrap
            [:span.process-step__label
             "Choose"
             [:span.clip-text.unclip-text--m
              " your design"]]]]]

         :else
         [:span.process-step__wrapper
          [:span.align-outer-wrap
           [:span.align-inner-wrap
            [:span.process-step__label
             "Choose"
             [:span.clip-text.unclip-text--m
              " your design"]]]]])]
      [:li
       {:class
        (u/bem
          :process-step
          [(cond
             (= step 2)
             :is-current

             (> step 2)
             :is-complete)])}
       (cond
         (= action "previewvoucher")
         [:a.process-step__wrapper
          (merge
            (urlstate/href-props app-atom "gift-vouchers" "createvoucher"
              {:method method
               :coverid (:cover/id cover)})
            {:class "block-link"})
          [:span.process-step__wrapper
           [:span.align-outer-wrap
            [:span.align-inner-wrap
             [:span.process-step__label
              "Create"
              [:span.clip-text.unclip-text--m
               " your voucher"]]]]]]

         :else
         [:span.process-step__wrapper
          [:span.align-outer-wrap
           [:span.align-inner-wrap
            [:span.process-step__label
             "Create"
             [:span.clip-text.unclip-text--m
              " your voucher"]]]]])]
      [:li
       {:class (u/bem :process-step [(when (= step 3) :is-current)])}
       [:span.process-step__wrapper
        [:span.align-outer-wrap
         [:span.align-inner-wrap
          [:span.process-step__label
           [:span.clip-text.unclip-text--m
            "Add to "]
           "Cart"]]]]]]]))